<template>
    <div class="home" style="background-color: #181a1b; color: white; padding: 0px; margin-top: 10px; border-radius: 10px;">
    </div>
    <button @click="submit" class="btn btn-primary btn-block">
            Get Unlimited!
    </button>
</template>
<script>
import {endpoint} from '@/utils/endpoint/endpointUtils';
import {getCookie} from '@/utils/cookies/cookieUtils';
export default {
    data() {
        return {
            /* Test Key */
            //publishableKey: 'pk_test_51Orh1sBb7mvKfBCOOYCOoGtjmWjex34V2CTY3RtBn55XGWrRx1az1Tl1PaMvTTAelmlk2KImiRfKT3xL4zJPXrxH000XsXhNE0',
            /* Live Key */
            publishableKey: 'pk_live_51Orh1sBb7mvKfBCO634GGKgAa2A0KP4j7M5EpvU9iolrQYfZhaU16il0KiyGdxJYMTcdZHY3F9DEFB2py4iZE9Bg00qOSYRxqw',
            lineItems: [
                {
                    /* Test Price */
                    //price: 'price_1OxZYvBb7mvKfBCOJEzD5LW4', 
                    /* Live Price */
                    price: 'price_1OrhwbBb7mvKfBCOU6jCT78R',
                    quantity: 1,
                }
            ],
            successUrl: 'https://www.skillsynchrony.com/unlimited-purchase-thanks',
            cancelUrl: 'https://www.skillsynchrony.com/'
        }
    },
    methods: {
        async submit() {
            try {
                const stripe = Stripe(this.publishableKey);
                const userid = getCookie('userid');
                
                const { sessionId } = await fetch(endpoint + '/api/Subscription/CreateCheckoutSession', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        lineItems: this.lineItems,
                        successUrl: this.successUrl,
                        cancelUrl: this.cancelUrl,
                        priceId: 'price_1OrhwbBb7mvKfBCOU6jCT78R',
                        mode: 'subscription',
                        userId: userid,
                        quantity: 1
                    }),
                }).then(response => response.json());

                await stripe.redirectToCheckout({
                    sessionId: sessionId,
                });
            } catch(error) {
                console.error(error);
            }
        }
    }
}
</script>
<style scoped>
.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/unlimited-ad-1.png'); /* Replace 'path/to/your/image.jpg' with the path to your image */
    background-size:contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 560px;
}
</style>